
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditCardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Creditcard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nickname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useForSubscriptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useForPurchases"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":161}};
    doc.loc.source = {"body":"fragment CreditCardFields on Creditcard {\n  id\n  status\n  name\n  nickname\n  number\n  type\n  expDay\n  expMonth\n  expYear\n  useForSubscriptions\n  useForPurchases\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
